module.exports = __webpack_public_path__ + "static/media/cancelado.3deee155.png";